import React, { useCallback, useEffect, useState } from "react";
import Styles from "./NotificationContainer.module.css";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { ReactComponent as UpMark } from "../../../assets/images/UpMark.svg";
import { useSelector } from "react-redux";
import {
  getNotificationCount,
  handleNotifyApi,
  handleNotifyRead,
  markAllRead,
} from "../../../Services/Chat/Chat";
import { ErrorMessage, SuccessMessage } from "../../Toast/ErrorMessage";
import { formatDateTimeView } from "../../FormatDate";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";

const NotificationContainer = () => {
  const upcoming = useSelector((state) => state?.notificationSlice?.latest);
  const userId = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId
  );

  const [notificationModal, setNotificationModal] = useState(false);
  const [notify, setNotify] = useState([]);
  const [notifyCount, setNotifyCount] = useState(0);

  const handleNotify = useCallback(async () => {
    try {
      let res = await handleNotifyApi({ userId });
      if (res?.data?.notifications?.lendth === 0) {
        ErrorMessage("No Notifications Found");
      } else {
        setNotify(res?.data?.notifications || []);
      }
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
      setNotify([]);
    }
  }, [userId]);

  const handleCount = useCallback(async () => {
    try {
      const res = await getNotificationCount({ userId });
      const countValue = res?.data?.unreadCount || 0;
      setNotifyCount(countValue);
    } catch (error) {
      console.error("Failed to fetch notification count:", error);
      setNotifyCount(0);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      handleNotify();
      handleCount();
    }
  }, [userId, upcoming, handleNotify, handleCount]);

  const handleRead = async (id) => {
    console.debug("Marking notification as read");
    let res = await handleNotifyRead({ id });
    if (res?.data?.message) {
      handleNotify();
      handleCount();
    }
  };

  const handleMarkAllRead = async () => {
    try {
      setNotifyCount(0);
      setNotificationModal(false);
      toast.info("Marking all as read...");

      let res = await markAllRead({ userId });
      if (res?.message || res?.data?.code === 200) {
        toast.success(
          res?.data?.message ||
            res?.message ||
            "All notifications marked as read"
        );
        handleNotify();
        handleCount();
      }
    } catch (error) {
      console.error("Failed to mark all notifications as read:", error);
      ErrorMessage("Failed to mark all as read");
      handleCount(); 
    }
  };

  useEffect(() => {
    if (userId) {
      handleNotify();
    }
  }, [userId, upcoming, handleNotify]);

  return (
    <div>
      <div
        className={Styles.notificationIconContainer}
        onClick={() => setNotificationModal(!notificationModal)}
      >
        <div className={Styles.countContianer}>
          {/* {notify?.filter((ele) => !ele?.isRead)?.length > 10
            ? "10+"
            : notify?.filter((ele) => !ele?.isRead)?.length} */}
          {notifyCount > 10 ? "10+" : notifyCount}
        </div>
        {upcoming || notify?.filter((ele) => !ele?.isRead)?.length > 0 ? (
          <NotificationsIcon style={{ color: "#b8b5c5ff" }} />
        ) : (
          <NotificationsNoneIcon style={{ color: "#b8b5c5ff" }} />
        )}
      </div>
      {notificationModal && (
        <div
          className={Styles.notificationModal}
          onMouseLeave={() => setNotificationModal(false)}
        >
          <div className={Styles.notificationModalHeader}>
            <UpMark />
          </div>
          <div className={`scroll_bar_y ${Styles.notifyContenet}`}>
            <span className={Styles.markAllRead} onClick={handleMarkAllRead}>
              Mark all as read
            </span>
            {notify?.map((ele) => (
              <div
                key={ele?.id}
                className={Styles.singleNotification}
                onMouseEnter={() => !ele?.isRead && handleRead(ele?.id)}
              >
                <div className={Styles.msgHeading}>{ele?.title}</div>
                <div className={Styles.msgDetails}>{ele?.message}</div>
                <div className="display_flex_row">
                  <div className={Styles.msgDate}>
                    {formatDateTimeView(ele?.created_at)}
                  </div>
                  <>
                    {ele?.isRead && (
                      <CheckCircleIcon
                        style={{ fontSize: "12px", color: "green" }}
                      />
                    )}
                  </>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationContainer;
